/**
 * PostStatsRefreshReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * PostStatsRefreshReq
 */
export interface PostStatsRefreshReq {
  /** 帖子ID列表（可选，为空时刷新所有帖子） */
  post_ids?: string[]
  /** 每批处理数量，默认100，最大1000 */
  limit?: number
}

/**
 * PostStatsRefreshReq Schema
 */
export const PostStatsRefreshReqSchema: SchemaDefinition = {
  properties: {
    post_ids: {
      description: '帖子ID列表（可选，为空时刷新所有帖子）',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '帖子ID列表',
    },
    limit: {
      description: '每批处理数量，默认100，最大1000',
      format: 'int',
      maximum: 1000,
      minimum: 0,
      type: 'integer',
      label: '每批处理数量',
    },
  },
  type: 'object',
}
